/**
 * Cross-browser clipboard copy that also works inside iframes where the
 * modern Clipboard API is blocked by a permissions-policy (e.g. the
 * Emergent preview at app.emergent.sh/chat).
 *
 * Returns true on success, false if both the modern API and the legacy
 * execCommand fallback fail.
 */
export async function copyToClipboard(text) {
  const value = text == null ? "" : String(text);
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(value);
      return true;
    }
  } catch {
    /* fall through to legacy path */
  }
  try {
    const ta = document.createElement("textarea");
    ta.value = value;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.top = "-1000px";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}
